import stylesheet from './InputField.scss?inline';
import {NXTBaseInput} from './Input';

export abstract class NXTInputField<ValueType = string> extends NXTBaseInput<ValueType> {
    private inputFieldWrapper?: HTMLElement;
    private errorSlot?: HTMLSlotElement;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get error(): boolean {
        return (this.errorSlot?.assignedElements().length ?? 0) > 0;
    }

    get stretchField(): boolean {
        return this.hasAttribute('stretch');
    }

    protected abstract renderControl(): HTMLElement;

    protected renderHint(): HTMLElement {
        const hint = document.createElement('div');
        hint.classList.add('input-hint');
        hint.innerHTML = `<slot name="hint"></slot>`;
        return hint;
    }

    protected renderError(): HTMLElement {
        const error = document.createElement('div');
        error.classList.add('input-error');
        error.innerHTML = `<slot name="error"></slot>`;
        return error;
    }

    render(): HTMLElement {
        const wrapper = document.createElement('div');
        wrapper.classList.add('input-field');
        if (this.stretchField) {
            wrapper.classList.add('stretch');
        }
        const field = document.createElement('div');
        field.classList.add('field');
        field.append(this.renderControl(), this.renderError(), this.renderHint());
        wrapper.append(this.renderLabel(), field);
        this.setHasSlottedToParent(wrapper);
        this.inputFieldWrapper = wrapper;
        this.errorSlot = wrapper.querySelector<HTMLSlotElement>('slot[name="error"]') ?? undefined;
        this.errorSlot?.addEventListener('slotchange', () => this.syncErrorState());
        this.syncErrorState();
        return wrapper;
    }

    private syncErrorState() {
        this.inputFieldWrapper?.classList.toggle('has-error', this.error);
    }
}
